export const UNIT_PRICE_HEADER = [
  { label: '社員コード', sortable: false, sortKey: '', width: '100px' },
  { label: '氏名', sortable: false, sortKey: '', width: '200px' },
  { label: '1月', sortable: false, sortKey: '', width: '100px' },
  { label: '2月', sortable: false, sortKey: '', width: '100px' },
  { label: '3月', sortable: false, sortKey: '', width: '100px' },
  { label: '4月', sortable: false, sortKey: '', width: '100px' },
  { label: '5月', sortable: false, sortKey: '', width: '100px' },
  { label: '6月', sortable: false, sortKey: '', width: '100px' },
  { label: '7月', sortable: false, sortKey: '', width: '100px' },
  { label: '8月', sortable: false, sortKey: '', width: '100px' },
  { label: '9月', sortable: false, sortKey: '', width: '100px' },
  { label: '10月', sortable: false, sortKey: '', width: '100px' },
  { label: '11月', sortable: false, sortKey: '', width: '100px' },
  { label: '12月', sortable: false, sortKey: '', width: '100px' },
  { label: '平均', sortable: false, sortKey: '', width: '100px' },
];
